import React, { useEffect, useState } from 'react';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';

import './../text-editor/style.scss';
import { PaddingType } from '../../puck/reusable-props/padding';
import { getPaddingStyles } from '../../utils/helper';
import {
  setCheckoutErrorMessage,
  setIsTermsAccepted,
  setVariantIdToAddIsTermsAccepted,
} from '../../redux/slices/commonSlice';
import ArrowDown from '../../../assets/svg/ArrowDown';
import { CartProductsProps } from './appProduct';
import { setCartData, setIsCartLoading } from '../../redux/slices/cartSlice';
import checkoutService from '../../api/checkoutService';
import { setAvailableShippingMethods } from '../../redux/slices/checkoutSlice';
import {
  LineItem,
  ShippingMethod,
  UpSellData,
} from '../../interface/checkoutInterface';
import { CheckoutUpdateItemsPayload } from '../../interface/apiServiceInterface';
import { IProductVariant } from '../../interface/storeInterface';
// import ToggleButton from '../../../components/common/toggleSwitchCustom';
import Toggle from '../../../components/common/toggleSwitchCustom';

export type TermsAndConditionProps = {
  showHeader: boolean;
  headerContent: string;
  showAcknowledgeDropdown: boolean;
  acknowledgeContent: string;
  padding: PaddingType;
  currentDeviceType: string;
  defaultChecked: boolean;
  backgroundColor: string;
  checkboxBorderColor: {
    checkedBorderColor: string;
    uncheckedBorderColor: string;
  };
  checkboxshape: string;
  checkboxSize: string;
  enrollmentStyle: string;
  checkMarkColor: string;
  checkedToggleColor: string;
  uncheckedToggleColor: string;
  toggleSize: string;
  checkMarkSize: string;
  checkBoxVerticalAlign: string;
  addProduct: CartProductsProps | null;
};
export const TermsAndConditionComponent = ({
  showHeader,
  headerContent,
  showAcknowledgeDropdown,
  acknowledgeContent,
  padding,
  currentDeviceType,
  backgroundColor,
  defaultChecked,
  checkboxBorderColor,
  checkboxshape,
  checkboxSize,
  enrollmentStyle,
  checkMarkColor,
  checkedToggleColor,
  uncheckedToggleColor,
  toggleSize,
  checkMarkSize,
  checkBoxVerticalAlign,
  useAppSelector,
  useAppDispatch,
  addProduct,
}: TermsAndConditionProps & ReduxDispatchProps & ReduxSelectorProps) => {
  const check = useAppSelector(state => state.common.isTermsAccepted);
  const { cartData } = useAppSelector(state => state.cart);
  const { pageId } = useAppSelector(state => state.checkout);
  const { storeData } = useAppSelector(state => state.store);
  const isCartLoading = useAppSelector(state => state.cart.isCartLoading);
  const dispatch = useAppDispatch();
  const [isopen, setIsOpen] = useState(false);
  useEffect(() => {
    dispatch(setIsTermsAccepted(defaultChecked));
  }, [defaultChecked]);

  const handleAdd = async () => {
    try {
      dispatch(setIsCartLoading(true));
      if (
        !cartData?.ID ||
        !addProduct ||
        !addProduct.variant ||
        !addProduct.variant.id
      ) {
        dispatch(setIsCartLoading(false));
        return;
      }
      const lineItems = [
        {
          Quantity: 1,
          VariantID: 'gid://shopify/ProductVariant/' + addProduct.variant?.id,
        },
      ];

      const payload = {
        ID: cartData?.ID,
        LineItems: lineItems,
        ShopID: storeData?.ShopID,
        StoreID: Number(storeData?.StoreID),
        PageID: String(pageId) || '',
      };

      const res = await checkoutService.checkoutAddItem(payload, {
        preUpsellData: [
          {
            ID: 'gid://shopify/Product/' + addProduct.variant?.id || '',
            ImageURL: addProduct.product?.image?.src || '',
            Title: addProduct.product?.title || '',
            OriginalPrice: addProduct?.variant?.price || 0,
            Variants: (addProduct.product?.variants || []).map(
              (variant: IProductVariant) => ({
                ID: 'gid://shopify/ProductVariant/' + variant.id || '',
                ImageURL: addProduct.product?.image?.src || '',
                OriginalPrice: variant.price || 0,
                Price: variant.price || 0,
                Title: variant.title || '',
              }),
            ),
            CurrencyCode: 'USD',
          },
        ] as unknown as UpSellData,
        cartData,
      });
      if (res?.data?.Cart) {
        dispatch(setCartData(res.data.Cart));
        dispatch(
          setAvailableShippingMethods(
            res.data.Cart.AvailableShippingMethods as ShippingMethod[],
          ),
        );
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        dispatch(setCheckoutErrorMessage(error.message)); // TODO: error message to sentry
      }
    } finally {
      dispatch(setIsCartLoading(false));
    }
  };

  const handleRemove = async () => {
    try {
      dispatch(setIsCartLoading(true));
      const lineItem = cartData?.LineItems.find(
        (item: LineItem) =>
          String(item.VariantID) ===
          'gid://shopify/ProductVariant/' + addProduct?.variant?.id,
      );

      const ID = lineItem?.ID;
      if (!ID || !addProduct?.variant || !cartData?.ID) {
        dispatch(setIsCartLoading(false));
        return;
      }

      const lineItems: [{ ID: string; Quantity: number; VariantID: string }] = [
        {
          ID: String(ID),
          Quantity: 0,
          VariantID: 'gid://shopify/ProductVariant/' + addProduct.variant?.id,
        },
      ];

      const payload: CheckoutUpdateItemsPayload = {
        ID: cartData.ID,
        LineItems: lineItems,
        ShopID: String(storeData?.ShopID),
        StoreID: Number(storeData?.StoreID),
        PageID: String(pageId) || '',
      };

      const res = await checkoutService.checkoutUpdateItems(payload, cartData);
      dispatch(setCartData(res.data.Cart));
      dispatch(
        setAvailableShippingMethods(
          res.data.Cart.AvailableShippingMethods as ShippingMethod[],
        ),
      );
    } catch (error: unknown) {
      if (error instanceof Error) {
        dispatch(setCheckoutErrorMessage(error?.message));
      }
    } finally {
      dispatch(setIsCartLoading(false));
    }
  };

  const addToCart = async (isAddOrRemove: boolean) => {
    if (addProduct?.enableAddProduct) {
      const isProductInCart = cartData?.LineItems?.some(
        (item: { VariantID: string | number }) =>
          String(item.VariantID) ===
          'gid://shopify/ProductVariant/' + addProduct?.variant?.id,
      );
      if (isAddOrRemove) {
        if (!isProductInCart) {
          await handleAdd();
        }
      } else {
        if (isProductInCart) {
          await handleRemove();
        }
      }
    }
  };
  useEffect(() => {
    if (defaultChecked) {
      addToCart(defaultChecked);
    }
    if (addProduct?.enableAddProduct && addProduct?.variant?.id) {
      dispatch(
        setVariantIdToAddIsTermsAccepted(
          'gid://shopify/ProductVariant/' + addProduct?.variant?.id,
        ),
      );
    } else {
      dispatch(setVariantIdToAddIsTermsAccepted(''));
    }
    return () => {
      dispatch(setVariantIdToAddIsTermsAccepted(''));
    };
  }, []);

  return (
    <React.Fragment>
      <div
        className={`py-2 text-editor-content `}
        style={{
          ...getPaddingStyles(padding, currentDeviceType),
        }}>
        <fieldset>
          <legend className="sr-only">Notifications</legend>
          <div className="space-y-2">
            <div className="flex">
              <div className={`flex h-auto ${checkBoxVerticalAlign} flex-col`}>
                {enrollmentStyle === 'checkbox' ? (
                  <input
                    type="checkbox"
                    className={`mt-1 cursor-pointer focus:ring-indigo-600 ${checkboxshape} border-gray-300`}
                    disabled={isCartLoading}
                    checked={check}
                    onChange={e => {
                      dispatch(setIsTermsAccepted(e.target.checked));
                      addToCart(e.target.checked);
                    }}
                    style={{
                      ...(backgroundColor && check ? { backgroundColor } : {}),
                      width: `${checkboxSize}px`,
                      height: `${checkboxSize}px`,
                      borderColor: check
                        ? checkboxBorderColor?.checkedBorderColor
                        : checkboxBorderColor?.uncheckedBorderColor,
                    }}
                  />
                ) : (
                  <Toggle
                    checked={check}
                    aria-describedby="comments-description"
                    style={{
                      backgroundColor: check
                        ? checkedToggleColor
                        : uncheckedToggleColor,
                      color: checkMarkColor,
                      width: `${toggleSize}px`,
                      height: `${toggleSize}px`,
                    }}
                    circleWidth={`${checkMarkSize}px`}
                    circleHeight={`${checkMarkSize}px`}
                    handleToggle={() => {
                      dispatch(setIsTermsAccepted(!check));
                      addToCart(!check);
                    }}
                  />
                )}
              </div>
              <div
                className="flex items-center justify-between w-full cursor-pointer"
                onClick={() => {
                  setIsOpen(!isopen);
                }}>
                {showHeader && (
                  <div
                    className="checkbox-text ml-3 text-left"
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: headerContent }}
                  />
                )}
                {!showHeader && (
                  <div
                    className="checkbox-text ml-3 text-left"
                    style={{ lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: acknowledgeContent }}
                  />
                )}
                {showAcknowledgeDropdown && (
                  <div className={`ml-auto flex py-2`}>
                    <ArrowDown
                      onClick={() => setIsOpen(!isopen)}
                      fill="black"
                      className={`${isopen ? 'transform rotate-[180deg]' : ''}  mx-2`}
                    />
                  </div>
                )}
              </div>
            </div>
            {showHeader && isopen && (
              <div
                className="checkbox-text ml-4 text-left"
                style={{ lineHeight: 1.5 }}
                dangerouslySetInnerHTML={{ __html: acknowledgeContent }}
              />
            )}
          </div>
        </fieldset>
      </div>
    </React.Fragment>
  );
};
